import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup, HookFormRadioButton } from "components";
import { float6Normalizer } from "validators";
import {
	floatToSixValidation,
	currencySixSigns,
	required,
} from "validators/validation";

import styles from "../softwareOptions.module.scss";

type TransarmorProps = {
	isLoading: boolean;
	disabled?: boolean;
	sectionName: string;
	isCloverManufacturer?: boolean;
	defaultValue?: { [key: string]: any };
};

const Transarmor = ({
	isLoading,
	disabled,
	sectionName,
	isCloverManufacturer,
	defaultValue,
}: TransarmorProps) => {
	const {
		register,
		watch,

		formState: { errors },
	} = useFormContext();
	const transarmor = watch(`${sectionName}.isTransarmorEnabled`);

	return (
		<>
			<p>Transarmor</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.transarmorYes`}
						name={`${sectionName}.isTransarmorEnabled`}
						register={register}
						value="true"
						defaultCheckedByValue={
							defaultValue?.isTransarmorEnabled
						}
						label="Yes"
						blurLoading={isLoading}
						disabled={disabled}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.transarmorNo`}
						name={`${sectionName}.isTransarmorEnabled`}
						register={register}
						value="false"
						defaultCheckedByValue={
							defaultValue?.isTransarmorEnabled
						}
						label="No"
						blurLoading={isLoading}
						disabled={disabled}
					/>
				</Col>
			</Row>
			{transarmor === "true" && (
				<Row>
					<Col md={5}>
						<HookFormInputGroup
							name={`${sectionName}.transarmorMonthlyFee`}
							key={`${sectionName}.transarmorMonthlyFee`}
							register={register}
							label="Transarmor Monthly Fee, $"
							defaultValue={defaultValue?.transarmorMonthlyFee}
							colInput={5}
							colLabel={7}
							blurLoading={isLoading}
							autoComplete="off"
							validator={isCloverManufacturer ? { required } : {}}
							showRequiredMark={isCloverManufacturer}
							readOnly
							isPlainText
							valueClassName={styles.plaintext}
						/>
					</Col>
					<Col md={{ span: 5, offset: 2 }}>
						<HookFormInputGroup
							key={`${sectionName}.transarmorPerTransactionFee`}
							name={`${sectionName}.transarmorPerTransactionFee`}
							register={register}
							label="Transarmor Per Transaction Fee, $"
							defaultValue={
								defaultValue?.transarmorPerTransactionFee
							}
							colInput={6}
							colLabel={6}
							blurLoading={isLoading}
							autoComplete="off"
							placeholder="0.000000"
							normalize={currencySixSigns}
							errors={errors}
							validator={
								isCloverManufacturer
									? { required, floatToSixValidation }
									: { floatToSixValidation }
							}
							normalizeOnBlur={float6Normalizer}
							showRequiredMark={isCloverManufacturer}
						/>
					</Col>
				</Row>
			)}
		</>
	);
};

export default Transarmor;
